"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHtmlFromROICalculator = void 0;
var escape_html_1 = __importDefault(require("escape-html"));
var ROICalculatorUtils_1 = require("../SharedWidgetComponents/ROICalculator/ROICalculatorUtils");
var createHtmlFromROICalculator = function (token, options) {
    if (!token.hasSelectedPreset) {
        return "";
    }
    var payload = createDataPayload(token, options);
    var stringifiedPayload = (0, escape_html_1.default)(JSON.stringify(payload));
    return "<div data-widget-type=\"roi-calculator\" data-payload=\"".concat(stringifiedPayload, "\" class=\"project-block__block-element roi-calculator\"></div>");
};
exports.createHtmlFromROICalculator = createHtmlFromROICalculator;
var createDataPayload = function (token, options) {
    var inputs = token.inputs;
    var slider = token.slider;
    var roiResult = token.roiResult;
    var title = token.title;
    var description = token.description;
    var backgroundImageUrl = (0, ROICalculatorUtils_1.getOptimisedRoiBackgroundImageUrl)({
        backgroundImageUrl: token.backgroundImageUrl,
        disableImgix: !!options.disableImgix,
        isPrintMode: options.isPrintMode,
    });
    return {
        inputs: inputs,
        slider: slider,
        roiResult: roiResult,
        title: title,
        description: description,
        backgroundImageUrl: backgroundImageUrl,
        useStaticRangeInput: !!options.isPrintMode,
    };
};
